// extracted by mini-css-extract-plugin
module.exports = {"container":"OrderForm__container","serverError":"OrderForm__serverError"};